const API_BASE_URL = 'https://servicodados.ibge.gov.br/api/v1/localidades';

export const locationService = {
  // Buscar todos os estados brasileiros
  async getStates() {
    try {
      const response = await fetch(`${API_BASE_URL}/estados`);
      if (!response.ok) {
        throw new Error('Erro ao buscar estados');
      }
      const states = await response.json();
      
      // Retornar estados ordenados por nome
      return states
        .map(state => ({
          id: state.id,
          nome: state.nome,
          sigla: state.sigla
        }))
        .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    } catch (error) {
      console.error('Erro ao buscar estados:', error);
      throw error;
    }
  },

  // Buscar cidades por estado
  async getCitiesByState(stateId) {
    try {
      const response = await fetch(`${API_BASE_URL}/estados/${stateId}/municipios`);
      if (!response.ok) {
        throw new Error('Erro ao buscar cidades');
      }
      const cities = await response.json();
      
      // Retornar cidades ordenadas por nome
      return cities
        .map(city => ({
          id: city.id,
          nome: city.nome
        }))
        .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    } catch (error) {
      console.error('Erro ao buscar cidades:', error);
      throw error;
    }
  },

  // Filtrar estados por nome (para busca em tempo real)
  filterStates(states, searchTerm) {
    if (!searchTerm) return states;
    
    const term = searchTerm.toLowerCase().trim();
    return states.filter(state => 
      state.nome.toLowerCase().includes(term) || 
      state.sigla.toLowerCase().includes(term)
    );
  },

  // Filtrar cidades por nome (para busca em tempo real)
  filterCities(cities, searchTerm) {
    if (!searchTerm) return cities;
    
    const term = searchTerm.toLowerCase().trim();
    return cities.filter(city => 
      city.nome.toLowerCase().includes(term)
    );
  }
};
